import { TCountryCode } from 'countries-list';
import apiCall from './apiCall';

export type InspectionsListShipOperator = {
    yearInspection: number,
    monthInspection: number,
    totalInspection: number,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number,
    invoicesSentToOperator: number,
    invoicesInFinance: number,
    invoicesSentToOperatorAndApprove: number,
    invoicesInProgress: number,
    inspectionInvoicesCompleted: number,
    inspectionInvoicesPaid: number,
    inspectionInvoicesNotYetPaid: number
};

export type InspectionReportByCompany = {
    yearInspection: number,
    monthInspection: number,
    totalInspection: number,
    inspectingCompanyId: string,
    companyName: string,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number,
    inspectionInvoicesToInspectionCompanyCompleted: number,
    inspectionInvoicesToInspectionCompanyPaid: number,
    inspectionInvoicesToInspectionCompanyProcess: number,
};

export type InvoicesInspectingCompany = {
    yearInspection: number,
    monthInspection: number,
    totalInspection: number,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number,
    invoicesSentByInpectionCompany: number,
    invoiceApprovedByPMSol: number,
    inspectionInvoicesToInspectionCompanyCompleted: number,
    inspectionInvoicesToInspectionCompanyPaid: number,
    inspectionInvoicesToInspectionCompanyProcess: number
};

export type InspectionByCountry = {
    yearInspection: number,
    monthInspection: number,
    country: TCountryCode,
    totalInspection: number,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number
};

export type SireReviewResults = {
    yearSireReview: number,
    monthSireReview: number,
    totalSireReview: number,
    reviewResultRecommended: number,
    reviewResultNotRecommended: number,
    sireReviewInProgress: number
};

export type SireReviewByRequestor = {
    yearSireReview: number,
    monthSireReview: number,
    totalSireReview: number,
    requestorId: string,
    requestor: string,
    reviewResultRecommended: number,
    reviewResultNotRecommended: number,
    sireReviewInProgress: number
};

export type InspectionByMarket = {
    yearInspection: number,
    monthInspection: number,
    market: string,
    totalInspection: number,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number
};

export type InspectionByInspector = {
    yearInspection: number,
    monthInspection: number,
    totalInspection: number,
    inspectorId: string,
    inspectorName: string,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number,
    invoicesSentToOperator: number,
    invoicesInFinance: number,
    invoicesSentToOperatorandApprove: number,
    invoicesInProgress: number,
    inspectionInvoicesCompleted: number,
    inspectionInvoicesPaid: number,
    inspectionInvoicesNotYetPaid: number,
    inspectorCountry: string,
};

export type InvoiceByStatus = {
    yearInvoice: number,
    monthInvoice: number,
    totalInvoice: number,
    invoicesSentToOperator: number,
    invoicesInFinance: number,
    invoicesSentToOperatorandApprove: number,
    invoicesInProgress: number,
    inspectionInvoicesCompleted: number,
    inspectionInvoicesPaid: number,
    inspectionInvoicesNotYetPaid: number,
};

export type InspectionsProfit = {
    yearInspection: number,
    monthInspection: number,
    totalInspection: number,
    inspectionCompanyInvoicesCompleted: number,
    inspectionCompanyInvoicesPaid: number,
    operatorInvoicesCompleted: number,
    operatorInvoicesPaid: number,
    profitCompleted: number,
    profitPaid: number,
};

export type SireReviewProfit = {
    yearSireReview: number,
    monthSireReview: number,
    totalSireReview: number,
    requestorInvoicesCompleted: number,
    requestorInvoicesPaid: number,
    sireReviewInvoicesCompleted: number,
    sireReviewInvoicesPaid: number,
    profitCompleted: number,
    profitPaid: number,
};

export type InspectionsByOperator = {
    yearInspection: number,
    monthInspection: number,
    country: string,
    shipOperatorId: string,
    shipOperatorName: string,
    totalInspection: number,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number,
};

export type InspectionsByOperatorCountry = {
    yearInspection: number,
    monthInspection: number,
    country: TCountryCode,
    totalInspection: number,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number,
    market: string, // This field is added to be able to filter the data by market in the ChartInspectionsByShipOperatorByCountry component, value is TC || 3rd for now but can be extended in the future if needed
};

export type InspectionsByOperatorByCountry = {
    yearInspection: number,
    monthInspection: number,
    country: TCountryCode,
    shipOperatorId: string,
    shipOperatorName: string,
    totalInspection: number,
    acceptedNominationInspectionProcess: number,
    cancelledNominationInspectionProcess: number,
    inProgressNominationInspectionProcess: number,
    inProgressInspectionProcess: number,
    finishedInspectionProcess: number,
    finishedInspectionProcessNotYetInvoices: number,
    market: string,
};

export type InspectionStatusData = {
    yearInspection: number,
    monthInspection: number,
    sequenceID: string,
    inspectionDate: string,
    requestDate: string,
    vesselName: string,
    inspectingCompanyName: string,
    shipOperatorName: string,
    requestShipOperator: number | boolean,
    requestInspectingCompany: number | boolean,
    inspectionProcess: number | boolean,
    inspectionResult: number | boolean,
    shipOperatorInvoiceStatus: number | boolean,
    shipOperatorPaymentStatus: number | boolean,
    shipOperatorInvoiceTotalAmount: number,
    inspectingCompanyInvoiceStatus: number | boolean,
    inspectingCompanyPaymentStatus: number | boolean,
    inspectingCompanyInvoiceTotalAmount: number,
    market: string,
};

export const getInspectionsByStatus = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionReportShipOperator?year=${year}&month=${month}`
    )
);

export const getInspectionsByCompany = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionReportperInspectionCompany?year=${year}&month=${month}`
    )
);

export const getInvoicesInspectingCompany = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionInvoiceReportperInspectionCompany?year=${year}&month=${month}`
    )
);

export const getInvoicesShipOperator = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionInvoiceReportperShipOperator?year=${year}&month=${month}`
    )
);

export const getInspectionsByCountry = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionWorldMap?year=${year}&month=${month}`
    )
);

export const getSireReviewResults = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionSireReviewbyResult?year=${year}&month=${month}`
    )
);

export const getSireReviewByRequestor = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionSireReviewbyRequestor?year=${year}&month=${month}`
    )
);

export const getInspectionsByMarket = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionByMarket?year=${year}&month=${month}`
    )
);

export const getInspectionsByInspector = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionReportperInspector?year=${year}&month=${month}`
    )
);

export const getInspectionsProfit = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionProfit?year=${year}&month=${month}`
    )
);

export const getSireReviewProfit = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetSireReviewProfit?year=${year}&month=${month}`
    )
);

export const getInspectionsByOperatorCountry = (month: number, year: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionByCountryShipOperator?year=${year}&month=${month}`
    )
);

export const getInspectionsByOperatorByCountry = (month: number, year: number, country: TCountryCode) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionByCountryShipOperatorperCountry?year=${year}&month=${month}&country=${country}`
    )
);

export const getInspectionsStatusTable = (month: number, year: number, search: string, market: string, pageNumber: number, pageSize: number) => (
    apiCall(
        'get',
        `/Dashboard/GetInspectionInformationStatus?year=${year}&month=${month}&search=${search}&market=${market}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    )
);
